import React from "react";
import { Rainbow, Brain, Accessibility, HeartPulse, Rocket, Medal, Users2 } from "lucide-react";

const ICONS = { Rainbow, Brain, Accessibility, HeartPulse, Rocket, Medal };
export const CommunityIcon = ({ name, className = "w-5 h-5" }) => {
  const Comp = ICONS[name] || Users2;
  return <Comp className={className} />;
};

// Tailwind is purge-scanned, so we must reference each accent class literally.
export const accentClasses = (accent) => {
  const map = {
    rose:    { bg: "bg-rose-100 dark:bg-rose-500/15", text: "text-rose-700 dark:text-rose-300", ring: "ring-rose-500/30", grad: "from-rose-500 to-pink-500" },
    violet:  { bg: "bg-violet-100 dark:bg-violet-500/15", text: "text-violet-700 dark:text-violet-300", ring: "ring-violet-500/30", grad: "from-violet-500 to-fuchsia-500" },
    sky:     { bg: "bg-sky-100 dark:bg-sky-500/15", text: "text-sky-700 dark:text-sky-300", ring: "ring-sky-500/30", grad: "from-sky-500 to-cyan-500" },
    emerald: { bg: "bg-emerald-100 dark:bg-emerald-500/15", text: "text-emerald-700 dark:text-emerald-300", ring: "ring-emerald-500/30", grad: "from-emerald-500 to-teal-500" },
    amber:   { bg: "bg-amber-100 dark:bg-amber-500/15", text: "text-amber-800 dark:text-amber-200", ring: "ring-amber-500/30", grad: "from-amber-500 to-orange-500" },
    slate:   { bg: "bg-slate-200 dark:bg-slate-500/15", text: "text-slate-800 dark:text-slate-200", ring: "ring-slate-500/30", grad: "from-slate-600 to-slate-800" },
  };
  return map[accent] || map.slate;
};
